import { Routes } from '@angular/router';
import { LaunchDarklyUserGuard } from 'remarketing-angular-library';
import { AgreementsGuard, GUARDS } from 'smartauction-frontend-micro-library';

export const ambassadorRoutes: Routes = [
  {
    path: 'ambassador-home',
    loadComponent: () => import('./components/ambassador-shell/ambassador-shell.component').then(c => c.AmbassadorShellComponent),
    canActivate: [
      LaunchDarklyUserGuard,
      AgreementsGuard
    ],
    data: {
      flag: 'ambassadorEnabled',
      guards: [
        GUARDS.TermsOfUseGuard,
        GUARDS.PrivacyPolicyGuard
      ]
    }
  }
];
